export const UPLOADED_COMMENTS_TAB_I18N_PREFIX = "features.home.components.uploaded_comments_tab";

export const UPLOADED_COMMENTS_TAB_I18N_KEYS = {
  no_articles_uploaded_comments_tab_message: "no_articles_uploaded_comments_tab_message",
  its_empty_uploaded_comments_tab_message: "its_empty_uploaded_comments_tab_message"
}


// WEBPACK FOOTER //
// ./src/features/home/components/constants/i18n/UploadedCommentsTabi18nConstants.js